import { render, staticRenderFns } from "./TabComposizioneOre.vue?vue&type=template&id=d0596886&scoped=true&"
import script from "./TabComposizioneOre.vue?vue&type=script&lang=js&"
export * from "./TabComposizioneOre.vue?vue&type=script&lang=js&"
import style0 from "./TabComposizioneOre.vue?vue&type=style&index=0&id=d0596886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0596886",
  null
  
)

export default component.exports